export default {
  brandRed: '#D93B3A',
  brandBlue: '#315596',
  brandYellow: '#E0B341',
  black: '#0C0C0C',
  vLightGrey: '#EFEFEF',
  medGrey: '#7B7B7B',
  darkGrey: '#333',
  white: '#FFF',
};